export const STATUS_COLUMNS = [
  { key: 'backlog', label: 'Chờ xử lý' },
  { key: 'to_do', label: 'Cần làm' },
  { key: 'in_progress', label: 'Đang làm' },
  { key: 'done', label: 'Hoàn thành' },
];

export const TYPE_OPTIONS = [
  { key: 'bug', label: 'Lỗi', emoji: '🐛' },
  { key: 'feature', label: 'Tính năng', emoji: '✨' },
];

export const PRIORITY_OPTIONS = [
  { key: 'low', label: 'Thấp', color: 'default' },
  { key: 'medium', label: 'Trung bình', color: 'primary' },
  { key: 'high', label: 'Cao', color: 'error' },
];

export const typeMeta = (type) =>
  TYPE_OPTIONS.find((t) => t.key === type) || TYPE_OPTIONS[0];

export const priorityMeta = (priority) =>
  PRIORITY_OPTIONS.find((p) => p.key === priority) || PRIORITY_OPTIONS[1];

export const statusLabel = (status) => {
  const col = STATUS_COLUMNS.find((c) => c.key === status);
  return col ? col.label : status;
};
